import { render } from "./noResult.vue?vue&type=template&id=387252dc&ts=true"
import script from "./noResult.vue?vue&type=script&lang=ts&config=true"
export * from "./noResult.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__